import { Spinner } from "react-bootstrap";

const SpinnerWithText = ({ text = "" }) => {
  return (
    <div className="d-flex justify-content-center gap-2">
      <Spinner animation="border" size="sm" variant="primary" />
      <span>{text}</span>
    </div>
  );
};

export default SpinnerWithText;
